export default {
    title: `Les essentiels`,
    subTitle: `L’activité économique vue par Alan Mudie, responsable de la stratégie d’investissement de Société Générale Private Banking.`,
    keyFigures: [
          {
            figure: 4,
            suffix: `billions $`,
            content: `Selon une étude du Bureau national de recherche économique (NBER), le réchauffement climatique a coûté au moins 4 billions de dollars cumulés aux États-Unis et à l’Union européenne en termes de perte de production depuis 2000.`,
            source: `Source: étude « Climatic Constraints on Aggregate Economic Output », 2019.`,
        },

        {
            prefix: `8,8`,
            suffix: `%`,
            content: `C’est le taux de croissance prévu en 2019 par le FMI pour le Ghana, qui décrocherait ainsi la palme mondiale dans ce domaine. Ce résultat s’explique en partie par les richesses naturelles dont dispose le pays – pétrole, cacao et or –, mais aussi par les mesures de réforme structurelle implémentées et par la stabilité démocratique. Cinq autres pays africains rejoindraient le Ghana dans le Top 10 planétaire : le Sénégal, la Côte d’Ivoire, l’Éthiopie, le Rwanda et le Soudan du Sud. <br/>`,
            source: `Source : Fonds monétaire international, 2018.`,
        },

        {
            figure: 3,
            suffix: `M`,
            content: `C’est le montant en dollars qu’a gagné en avril 2019 le vainqueur de la Coupe du monde de… <em>Fortnite</em>. Avec 250 millions de joueurs, ce jeu vidéo est devenu l’un des sports les plus populaires du monde. À titre de comparaison, chaque vainqueur du tournoi de simple à Wimbledon a remporté 2,9 millions de dollars. Et celui du marathon de New York ? 100 000 dollars ! `,
            source: `Source: <a href="http://epicgames.com" target="_blank">epicgames.com</a>`,
        },

        {   
            prefix: `12 000`,
            suffix: `Md$`,
            content: `Selon les chercheurs du McKinsey Global Institute, si chaque pays se hissait au niveau du meilleur de sa région économique en matière d’égalité femmeshommes, cela ajouterait 12 000 milliards de dollars à l’économie globale d’ici à 2025, soit l’équivalent du PIB du Japon, du Royaume-Uni et de l’Allemagne réunis. Toutefois, ces mêmes chercheurs ont souligné, cette année, que l’avènement de la robotique couplée à l’intelligence artificielle mettrait en péril ces perspectives si les femmes n’ont pas accès aux formations idoines.`,
            source: `Source: McKinsey Global Institute, 2015.`,
        },

        {
            prefix: `1,43`,
            content: `Le Japon subit une crise démographique, chacun le sait – sa population régresse globalement tout en vieillissant. Ce qui se sait moins, c’est que le point bas a déjà été atteint en 2005 avec 1,26 naissance par femme, suivi par 1,39 en 2010 ; avec une légère remontée à 1,43 en 2017, peut-être due aux politiques de <em>womenomics</em> prônées par les autorités. Toutefois, il faudrait prolonger cette tendance pour atteindre les 2,1 naissances nécessaires afin de maintenir cette population constante. `,
            source: `Source: <a href="http://data.worldbank.org" target="_blank">data.worldbank.org</a>`,
        },

        {
            prefix: `41 363`,
            suffix: `%`,
            content: `Selon Global Financial Data, c’est la progression cumulée du prix moyen d’une maison en Grande- Bretagne depuis 1939, soit 8% annualisés. La progression jusqu’à cette date n’avait été que de 887 %, sur un historique qui commence en… 1290 ! En termes ajustés par l’inflation, les prix ont chuté de 49 % entre 1290 et 1939, pour ensuite progresser de 834 %. La période récente serait-elle une anomalie historique ? `,
            source: `Source: Global Financial Data.`,
        },

    ]
};

